import React, {useState, useEffect} from 'react';
import {DialogWindow, CustomAvatar} from  './general';
import { getCreditDetailsByUser, repayCredit } from '../services/credit.js'
import { getBookingById } from '../services/booking.js'
import { Box, Card, Typography, Stack, Checkbox, Button, IconButton, Badge, Divider, TextField } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import dayjs from 'dayjs';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useSnackbar } from '../context/snackbarContext.js';
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { removeUserAction } from "../actions/profile.js"

const classes = {
     rowInd: {
        margin: '0px 10px'
    },
    prodCont: {
        display: 'flex',
        flexDirection:'column',
        width: '33%'
    },
    indProductCont: {
        display: 'flex',
        alignItems: 'center'
    },
    indProductItem: {
        marginLeft: '10px'
    },
    noteCont:{
        width:'33%'
    },
    indNoteCont: {
        marginBottom: '5px'
    },
    noteTitle:{
        fontWeight: 'bold',
        fontSize: '14px',
        textDecoration: 'underline'
    },
    note: {
        fontSize: '14px'
    }
}

const DateBar = ({from, to}) =>{
    if ( from && to ) {
        return (
            <Box sx={{display: 'table'}}>
                <Box sx={{display: 'table-row'}}>
                    <Box sx={{display: 'table-cell', verticalAlign: "middle", textAlign: 'start'}}>
                        <CalendarMonthIcon/>
                    </Box>
                    <Box sx={{display: 'table-cell', verticalAlign: "middle", textAlign: 'start'}}>
                        <Typography style={classes.rowInd}>{dayjs(from).format('Do MMM YY (ddd)')}</Typography> 
                    </Box>
                    <Box sx={{display: 'table-cell', verticalAlign: "middle", textAlign: 'start'}}>
                        <Typography style={classes.rowInd}>{dayjs(to).format('Do MMM YY (ddd)')}</Typography>  
                    </Box>
                </Box>

                <Box sx={{display: 'table-row'}}>
                    <Box sx={{display: 'table-cell', verticalAlign: "middle", textAlign: 'start'}}>
                        <AccessTimeIcon/>  
                    </Box>
                    <Box sx={{display: 'table-cell', verticalAlign: "middle", textAlign: 'start'}}>
                        <Typography style={classes.rowInd}>{dayjs(from).format('HH:mm A')}</Typography> 
                    </Box>
                    <Box sx={{display: 'table-cell', verticalAlign: "middle", textAlign: 'start'}}>
                        <Typography style={classes.rowInd}>{dayjs(to).format('HH:mm A')}</Typography>
                    </Box>
                </Box>
            </Box>
        )
    }
    return null
}

const CashBar = ({billableDates, advance, discount}) => {
    return (
        <Stack direction="row" spacing={8}>
            <Typography>Billable Days : {billableDates?.length}</Typography>
            <Typography>Advance : ₹{advance || 0}</Typography>
            <Typography>Discount : ₹{discount || 0}</Typography>
        </Stack>
    )
}

const IndProduct = ({product, index}) => {
    return (
      
        <div style={classes.indProductCont}>
          <div style={classes.indProductItem}># {index+1}</div>
          <div style={classes.indProductItem}><img height={50} src={product?.image?.thumb??''}/></div>
          
          <div style={classes.indProductItem}>{product.name}</div>
          <Badge badgeContent={product.count} sx={{marginLeft:'15px'}} color="primary">
          </Badge>
        </div>
    )
}

const IndNote = ({title, note}) => {
    const titleMap = {
        bookingNotes: 'Booking Notes',
        checkoutNotes: 'Checkout Notes',
        checkinNotes: 'Checkin Notes'
    }
    if (note) {
        return (
            <Box>
                <Typography style={classes.noteTitle}>{titleMap[title]} :-</Typography>
                <Typography style={classes.note}>{note}</Typography>
            </Box>
        )
    }
    return (
            <Box>
                <Typography style={classes.note}>No {titleMap[title]}</Typography>
            </Box>
            );

}

const ProductsDetails = ({products}) => {
    if (Array.isArray(products) && products.length > 0)
    return (
        <Box style={classes.prodCont}>
            <Typography sx={{fontWeight: 'bold', mb:1 }}>Products</Typography>
            {products.map((product, index)=><IndProduct index={index} key={`product-${index}`} product={product}/>)}
        </Box>
    )
}
const PaymentHistory = ({installments}) => {
    if (Array.isArray(installments) && installments.length > 0) {
        return (
            <Stack direction="column" sx={{width: '33%'}}>
                <Typography sx={{fontWeight: 'bold', mb:1 }}>Payment History</Typography>
                {installments.map((installment)=>(
                    <Stack direction="row">
                        <Typography sx={{mr: 4}}>{dayjs(installment.paid_at).format('D MMM YYYY')}</Typography>
                        <Typography>₹ {installment.amount}</Typography>
                    </Stack>
                ))}
            </Stack>
        )
    }
    return (
        <Stack direction="column" sx={{width: '33%'}}>
             <Typography sx={{fontWeight: 'bold', mb:1 }}>Payment History</Typography>
            <Typography>No Paymnet History</Typography>
        </Stack>
    )
}
const BookingDetails = ({bookingDetails, credit}) => {
    return(
        <Box>
            <Divider/>
            <Stack direction="column" sx={{ml: 5, mt: 2}}>
                <Stack direction="row" justifyContent="space-between">
                    <CashBar billableDates={bookingDetails?.billableDates} advance={bookingDetails?.advance} discount={bookingDetails?.discount}/>
                    <DateBar from={bookingDetails?.from} to={bookingDetails?.to}/>
                </Stack>
                <Stack direction="row">
                    <ProductsDetails products={bookingDetails?.products}/>
                    <PaymentHistory installments={credit?.installments}/>
                    {bookingDetails?.notes && <Box style={classes.noteCont}>
                        <Typography sx={{fontWeight: 'bold', mb:1 }}>Notes</Typography>
                        {Object.keys(bookingDetails?.notes).map((note, index)=><IndNote index={index} key={`note-${index}`} title={note} note={bookingDetails?.notes[note]}/>)}
                    </Box>}
                </Stack>
            </Stack>
        </Box>
    )
}

const CreditRow = ({credit, openedRow, setOpenedRow, selectedAmounts, setSelectedAmounts}) =>{
    
    const [bookingDetails, setBookingDetails] = useState()
    
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const toggleExpansionClick = (id) => {
        return (e) => {            
            if (id === openedRow) {
                setOpenedRow()
            }
            else {
                setOpenedRow(id)
            }
        }
    }

    const getBookingDetail = async(id) => {
        try {
            const data = await getBookingById(id);            
            setBookingDetails(data);
        } catch (e) {
            if (e.status === 401) {
                dispatch(removeUserAction())
                navigate('/');
            }
            console.log(e)
        }
    }

    useEffect(()=>{        
        if (credit._id === openedRow) {
            getBookingDetail(credit.bookingId)
        }
    }, [openedRow])
    
    const updateSelectedAmounts = (amount) => {
        return (e) => {
            const isCheck = e.target.checked
            if (isCheck) {
                const _selectedAmounts = [...selectedAmounts];
                _selectedAmounts.push(amount)
                setSelectedAmounts(_selectedAmounts)
            } else {
                
                const _selectedAmounts = [...selectedAmounts];
                const index = _selectedAmounts.indexOf(amount)
                _selectedAmounts.splice(index, 1)
                setSelectedAmounts(_selectedAmounts)
            }
        }
    }

    return (
        <Card sx={{padding:2, margin:1}}>
            <Stack direction="row" alignItems="center" sx={{position:"relative"}}>
                <Checkbox onChange={updateSelectedAmounts(credit.remainingAmount)}/>
                <Typography sx={{mr: 1, fontWeight: 'bold' }}>{dayjs(credit.createdAt).format("DD/MM/YYYY")}</Typography>
                <Typography sx={{mr: 1, fontWeight: 'bold' }}>₹ {credit.remainingAmount}</Typography>
                <Typography sx={{mr: 1, fontWeight: 'bold' }}>{credit.dueDate}</Typography>
                <IconButton sx={{position:"absolute", right: 5}} onClick={toggleExpansionClick(credit._id)}>{openedRow === credit._id ? <ArrowDropUpIcon/> : <ArrowDropDownIcon/>}</IconButton>
            </Stack>
            {openedRow === credit._id && (<BookingDetails bookingDetails={bookingDetails} credit={credit}/>)}
        </Card>
    )
}

const TenantSection = ({tenant}) => {
    return(
        <Stack direction="row" sx={{ mb: 2 }} alignItems="center">
            <Box sx={{ mr: 2 }}>
                <img style={{ width: '100px', height: '100px', borderRadius: '50%' }}src={tenant.tenant?.image?.thumb}/>
            </Box>
            <Stack direction="column">
                <Typography sx={{ fontWeight: 'bold' }}>{ tenant.tenant.name }</Typography>
                <Typography sx={{ fontWeight: 'bold' }}>₹ { tenant.total }</Typography>
                <Typography sx={{fontSize: 12}}>{ tenant.tenant.contactNumber }</Typography>
            </Stack>
        </Stack>
    )
}

const ActionPanel = ({payingAmount, setIsPay, setShowPay, showPay, isPay, setPayingAmount, setSelectedAmounts, error, pay}) => {
    if (!showPay) {
        return (
            <Stack direction="row" justifyContent="flex-end" spacing={4}>
                <Button onClick={()=>{setIsPay(false); setShowPay(true)}} variant="outlined">Wave {payingAmount > 0 ? payingAmount : ""}</Button>
                <Button onClick={()=>{setIsPay(true); setShowPay(true)}} variant="contained">Pay {payingAmount > 0 ? payingAmount : ""}</Button>
            </Stack>
        )
    }
    return (
         <Stack direction="row" justifyContent="flex-end" spacing={4}>
            <Button onClick={()=>{setShowPay(false); setSelectedAmounts([])}} variant="outlined">Cancel</Button>
            <Button disabled={error} onClick={()=>{pay()}} variant="contained">{isPay ? 'Pay' : 'Wave'} </Button>
        </Stack>   
    )
}

const WaveOrPay = ({total, payingAmount=0, setPayingAmount, isPay, error, setError}) => {
    const balance = total - payingAmount
    
    return (
        <Box>
            <Stack sx={{ mb: 2 }} direction="row" alignItems="center">
                <Typography sx={{ mr: 4 }}>Amount to be {isPay ? "paid" : "waved"} </Typography>
                <TextField
                    size="small"
                    value={payingAmount}
                    onChange={(e)=>{
                        const newAmount = e.target.value.replace(/[^0-9.]/g, '')
                        if (newAmount > total) {
                            setError("Amount must not be above total")
                        } else {
                            setError();
                        }
                        setPayingAmount(newAmount)
                    }}
                    error={Boolean(error)}
                    helperText={error}
                    InputProps={{
                        inputMode: 'numeric', // Suggests numeric keyboard on mobile devices
                        pattern: '[0-9]*' // Helps with browser-level validation for type="number"
                    }}
                />
            </Stack>
            <Stack direction="row">
                <Typography>Balance :</Typography>
                <Typography> ₹ {error ? '' : balance}</Typography>
            </Stack>
        </Box>
    )
}

const Body = ({creditDetails=[], isMobile, selectedTenant, open, setOpen}) => {
    const [openedRow, setOpenedRow] = useState()
    const [selectedAmounts, setSelectedAmounts] = useState([])
    const [showPay, setShowPay] = useState(false);
    const [isPay, setIsPay] = useState(true)
    const [payingAmount, setPayingAmount] = useState(0)
    const [error, setError] = useState()
    const { showSnackbar } = useSnackbar();

    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(()=>{
        setPayingAmount(selectedAmounts.reduce((acc, curr) => acc+curr, 0))
    }, [selectedAmounts])
    
    const pay = async() => {
        try {
            await repayCredit(selectedTenant.tenant._id, payingAmount)
            setOpen(false)
            showSnackbar(`Payment for ${payingAmount} completed!`, "success");
        } catch (e) {
            console.log(e)
            if (e.status === 401) {
               dispatch(removeUserAction())
               navigate('/');
            }
            showSnackbar("Could not make the payment", "error");
        }
    }

    return (
        <Box>
            <TenantSection tenant={selectedTenant}/>
            {!showPay && (<Box sx={{height: 500, overflowY: 'scroll'}}>
                <Stack direction="column">
                    {creditDetails.map(credit=><CreditRow key={`credit-${credit._id}`} credit={credit} openedRow={openedRow} setOpenedRow={setOpenedRow} selectedAmounts={selectedAmounts} setSelectedAmounts={setSelectedAmounts}/>)}
                </Stack>
            </Box>)}
            {showPay && (<WaveOrPay isPay={isPay} total={selectedTenant.total} payingAmount={payingAmount} setPayingAmount={setPayingAmount} error={error} setError={setError}/>)}
            <ActionPanel payingAmount={payingAmount} setShowPay={setShowPay} setIsPay={setIsPay} showPay={showPay} isPay={isPay} pay={pay} setPayingAmount={setPayingAmount} setSelectedAmounts={setSelectedAmounts} error={error}/>
        </Box>
    )
  }

export default function CreditDetails({isMobile, selectedTenant, open, setOpen}) {

    const [creditDetails, setCreditDetails] = useState([]);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(()=>{
        const getDetail = async() => {
            try {
                const _details = await getCreditDetailsByUser(selectedTenant.tenant._id)
                setCreditDetails(_details)
            } catch (e) {
                if (e.status === 401) {
                    dispatch(removeUserAction())
                    navigate('/');
                }
            }
        }
        if (open) {
            getDetail()
        }
      }, [open])

    return (
        <DialogWindow title={'Credit Details'} Body={<Body isMobile={isMobile} creditDetails={creditDetails} selectedTenant={selectedTenant} setOpen={setOpen}/>} Actions={null} open={open} setOpen={setOpen}  maxWidth={'lg'}/>
    )
}
